/* eslint-disable prefer-destructuring */
/* eslint-disable eqeqeq */
/* eslint-disable no-case-declarations */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import api from '../services/api';

import getQuestionsWithTranslations from './getQuestionsWithTranslations';

const getSurveyTransations = async (idSurvey: number): Promise<any[]> => {
  const surveyTranslations: any[] = [];
  const response = await api.get(
    `/surveyTranslations/translations/${idSurvey}`,
  );

  response.data.forEach((surveyTranslation: any) => {
    surveyTranslations.push(surveyTranslation);
  });
  return surveyTranslations;
};

const updateSurveyTranslations = async (
  surveyEncoded: any,
  idSurvey: number,
): Promise<any> => {
  const questionWithTranslations = await getQuestionsWithTranslations(
    surveyEncoded,
  );

  const surveyTranslations = await getSurveyTransations(idSurvey);
  surveyTranslations.forEach(async (surveyTranslation: any) => {
    const responseLanguage = await api.get(
      `languages/${surveyTranslation.languageId}`,
    );
    const placeHolderTexQuestion =
      responseLanguage.data?.placeholderTextQuestion ??
      'Tippen Sie Ihre Antwort bitte hier ein:';

    const pagesTranslated = surveyEncoded.pages.map((page: any) => {
      let pageTranslated: any = {};
      const elementsTranslated = page.elements.map((element: any) => {
        let questionWithTranslation: any = {};
        let elementTranslated: any = {};
        let questionTranslated: any = {};
        let rowsTranslated: any = {};
        let columnsTranslated: any = {};
        let elementsFlat: any[] = [];

        let translation: any = {};
        let questionIdToSearch = '';
        let alternativeId = '';
        let questionIdSplitted: string[];
        let alternativeText = '';
        let strQuyestionId = '';

        switch (element.type) {
          case 'dropdown':
          case 'ranking':
          case 'radiogroup':
          case 'barrating':
          case 'ebemotionsratings':
          case 'funnyemotionsratings':
          case 'dortmunderemotionsratings':
          case 'rating':
          case 'ebslider':
          case 'ebsliderpolarity':
          case 'ebverticalpolarity':
          case 'comment':
          case 'text':
          case 'checkbox':
          case 'ebdragndrop':
            translation = {};
            questionIdToSearch = '';
            alternativeId = '';
            questionIdSplitted = [];
            alternativeText = '';
            strQuyestionId = '';
            strQuyestionId = element.questionId.toString();
            questionIdToSearch = strQuyestionId;
            const translatedOptionsToInsert: any = [];

            let translatedQuestionsFlat;
            let descriptionTranslated = '';
            if (element.description) {
              translatedQuestionsFlat =
                surveyTranslation.translation.pages.flatMap(
                  ({ elements }: any) =>
                    elements?.flatMap((elementFlat: any) => ({
                      ...elementFlat,
                    })),
                );
              // eslint-disable-next-line no-case-declarations
              const questonTranslatedAlreadySaved =
                translatedQuestionsFlat.find(
                  (elementFlat: any) =>
                    elementFlat?.questionId === element?.questionId,
                );

              descriptionTranslated =
                questonTranslatedAlreadySaved?.description;
            }

            questionWithTranslation = questionWithTranslations.find(
              (question: any) => question.questionId == questionIdToSearch,
            );

            if (strQuyestionId.includes(`.`)) {
              questionIdSplitted = strQuyestionId.split('.');
              questionIdToSearch = questionIdSplitted[0];
              alternativeId = questionIdSplitted[1];

              questionWithTranslation = questionWithTranslations.find(
                (question: any) => question.questionId == questionIdToSearch,
              );

              translation = questionWithTranslation.translations.find(
                (questionTranslation: any) =>
                  questionTranslation.languageId ===
                  surveyTranslation.languageId,
              );
              const alternativeTextFound = translation?.alternatives?.find(
                (alternative: any) => alternative.value == alternativeId,
              );

              alternativeText = alternativeTextFound
                ? alternativeTextFound.text
                : questionWithTranslation.text;
            }

            if (
              questionWithTranslation &&
              questionWithTranslation?.translations
            ) {
              translation = questionWithTranslation.translations.find(
                (questionTranslation: any) =>
                  questionTranslation.languageId ===
                  surveyTranslation.languageId,
              );
            }

            if (element.choices && element.choices.length > 0) {
              element?.choices?.forEach((elementChoice: any) => {
                const transOption = translation?.options?.find(
                  (translationOption: any) => {
                    return elementChoice.value === translationOption.value;
                  },
                );

                translatedOptionsToInsert.push(transOption || elementChoice);
              });
            }

            elementTranslated = {
              ...element,
              description:
                !descriptionTranslated || descriptionTranslated === ''
                  ? element.description
                  : descriptionTranslated,
              title:
                alternativeText && alternativeText != ''
                  ? alternativeText
                  : translation?.text
                  ? translation?.text
                  : questionWithTranslation?.text,
              choices:
                translatedOptionsToInsert &&
                translatedOptionsToInsert.length > 0
                  ? translatedOptionsToInsert
                  : element.choices,
              rateValues:
                translatedOptionsToInsert &&
                translatedOptionsToInsert.length > 0
                  ? translatedOptionsToInsert
                  : element.rateValues,
            };

            if (element.type === 'text' || element.type === 'comment') {
              delete elementTranslated.choices;
              delete elementTranslated.rateValues;
            }

            if (element.internalType === 'Text') {
              elementTranslated = {
                ...elementTranslated,
                placeHolder: placeHolderTexQuestion,
              };
            }

            break;
          case 'matrix':
            elementsFlat = surveyTranslation.translation.pages.flatMap(
              ({ elements }: any) =>
                elements?.flatMap((elementFlat: any) => ({
                  ...elementFlat,
                })),
            );
            // eslint-disable-next-line no-case-declarations
            const matrixElement = elementsFlat.find(
              (elementFlat: any) => elementFlat?.name === element?.name,
            );

            rowsTranslated = element.rows.map((row: any) => {
              translation = {};
              questionIdToSearch = '';
              alternativeId = '';
              questionIdSplitted = [];
              alternativeText = '';
              strQuyestionId = '';

              strQuyestionId = row.questionId.toString();
              questionIdToSearch = strQuyestionId;

              questionWithTranslation = questionWithTranslations.find(
                (question: any) => question.questionId == questionIdToSearch,
              );

              if (strQuyestionId.includes(`.`)) {
                questionIdSplitted = strQuyestionId.split('.');
                questionIdToSearch = questionIdSplitted[0];
                alternativeId = questionIdSplitted[1];

                questionWithTranslation = questionWithTranslations.find(
                  (question: any) => question.questionId == questionIdToSearch,
                );

                translation = questionWithTranslation.translations.find(
                  (questionTranslation: any) =>
                    questionTranslation.languageId ===
                    surveyTranslation.languageId,
                );

                alternativeText = translation?.alternatives?.find(
                  (alternative: any) => alternative.value == alternativeId,
                )?.text;
              }

              if (questionWithTranslation?.translations) {
                questionTranslated =
                  questionWithTranslation?.translations?.find(
                    (questionTranslation: any) =>
                      questionTranslation.languageId ===
                      surveyTranslation.languageId,
                  );

                columnsTranslated = element?.columns?.map((column: any) => {
                  return (
                    questionTranslated?.options?.find(
                      (option: any) => option.value === column.value,
                    ) ?? column
                  );
                });
              }

              const rowTranslated = {
                ...row,
                text:
                  alternativeText && alternativeText != ''
                    ? alternativeText
                    : questionTranslated?.text
                    ? questionTranslated?.text
                    : questionWithTranslation.text,
              };

              return rowTranslated;
            });

            elementTranslated = {
              ...element,
              title:
                matrixElement && matrixElement.title
                  ? matrixElement.title
                  : element.title,
              rows: rowsTranslated.length > 0 ? rowsTranslated : element.rows,
              columns:
                columnsTranslated.length > 0
                  ? columnsTranslated
                  : element.columns,
            };

            break;
          case 'html':
            elementsFlat = surveyTranslation.translation.pages.flatMap(
              ({ elements }: any) =>
                elements?.flatMap((elementFlat: any) => ({
                  ...elementFlat,
                })),
            );
            // eslint-disable-next-line no-case-declarations
            const htmlElement = elementsFlat.find(
              (elementFlat: any) => elementFlat?.name === element?.name,
            );

            elementTranslated = {
              ...element,
              html:
                htmlElement && htmlElement.html
                  ? htmlElement.html
                  : element.html,
            };

            break;
          default:
            elementTranslated = element;
            break;
        }

        return elementTranslated;
      });
      pageTranslated = { ...page, elements: elementsTranslated };
      return pageTranslated;
    });

    const surveyTranslated = {
      ...surveyEncoded,
      title: surveyTranslation.translation.title ?? surveyEncoded.title,
      description:
        surveyTranslation.translation.description ?? surveyEncoded.description,
      pages: pagesTranslated,
    };

    const newSurveyTranslation = {
      ...surveyTranslation,
      translation: surveyTranslated,
    };

    delete newSurveyTranslation._id;
    delete newSurveyTranslation.__v;
    delete newSurveyTranslation.created_by;
    delete newSurveyTranslation.updated_by;
    delete newSurveyTranslation.created_at;
    delete newSurveyTranslation.updated_at;
    delete newSurveyTranslation.surveyId;
    delete newSurveyTranslation.surveyTranslationId;
    delete newSurveyTranslation.languageId;
    delete newSurveyTranslation.languageName;

    await api.put(
      `/surveyTranslations/${surveyTranslation.surveyTranslationId}`,
      newSurveyTranslation,
    );
  });
};

export default updateSurveyTranslations;
